var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPopular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_x30_5_Popular"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m396.619 194.325c-1.381-1.73-3.055-1.39-3.932-1.037-.735.298-2.419 1.25-2.186 3.636.28 2.865.437 5.786.467 8.683.125 12.018-4.696 23.792-13.226 32.303-8.476 8.456-19.624 13.012-31.494 12.88-16.214-.207-29.662-8.664-38.891-24.457-7.631-13.059-4.277-29.902-.726-47.735 2.078-10.438 4.227-21.232 4.227-31.505 0-79.989-53.774-126.137-85.828-146.526-.663-.421-1.294-.569-1.853-.569-.909 0-1.629.392-1.984.632-.688.466-1.789 1.528-1.435 3.408 12.252 65.062-24.292 104.193-62.982 145.621-39.88 42.703-85.081 91.104-85.081 178.396 0 101.428 82.517 183.945 183.945 183.945 83.512 0 157.143-58.224 179.055-141.59 14.942-56.843-.716-129.251-38.076-176.085zm-136.39 278.412c-25.398 1.158-49.552-7.951-68.001-25.591-18.251-17.452-28.719-41.807-28.719-66.821 0-46.941 17.948-81.401 66.222-127.149.79-.749 1.599-.986 2.304-.986.639 0 1.193.195 1.574.378.803.387 2.123 1.345 1.945 3.417-1.726 20.085-1.696 36.756.088 49.552 4.56 32.685 28.487 54.646 59.542 54.646 15.226 0 29.729-5.73 40.838-16.135 1.289-1.208 2.729-1.054 3.281-.937.731.158 1.71.606 2.223 1.843 4.606 11.121 6.96 22.926 6.996 35.085.147 48.925-39.461 90.51-88.293 92.698z",
    fill: "#ffffff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopular);
export default __webpack_public_path__ + "static/media/popular.cd073d418d6b8153df1a4d2205db38f1.svg";
export { ForwardRef as ReactComponent };